module.exports = __webpack_public_path__ + "static/media/icon-linkedin.1abb00f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-linkedin.svg
// module id = 510
// module chunks = 0